import * as React from "react"
import { useState } from "react";
import TextWithLinksParser from "../../TextWithLinksParser"
import ProductContentStyle1 from "../content/ProductContentStyle1";
import ProductContentStyle2 from "../content/ProductContentStyle2";
import ProductContentStyle3 from "../content/ProductContentStyle3";
import ProductContentStyle4 from "../content/ProductContentStyle4";
import ProductContentStyle5 from "../content/ProductContentStyle5";
import ProductContentStyle7 from "../content/ProductContentStyle7";
import ProductContentStyle8 from "../content/ProductContentStyle8";
import ProductContentStyle6 from "../content/ProductContentStyle6";
import { PRODUCT_TYPE_CARBON } from "../../constants";
import { BackButton } from "../../BackButton";
import './styles.scss'

export default function ProductItem({ itemData, isProductPassportView, isSectionOpen, setIsSectionOpen }) {
    const [selectedType, setSelectedType] = useState(PRODUCT_TYPE_CARBON);

    const scrollToTop = () => {
        if (typeof window !== "undefined") {
            window.scrollTo({ top: 0 });
        }
    };

    if (!itemData.title) return null;

    if (!isSectionOpen) {
        return (
            <div
                id={`${itemData.style}`}
                className="item"
                onClick={() => setIsSectionOpen(itemData.title)}
            >
                <div className="item-title">{itemData.title}</div>
            </div>
        )
    }

    if (isSectionOpen === itemData.title) {
        return (
            <div className="item-content" style={{ width: "100%" }}>
                <div className="content-header">
                    <BackButton
                        backAction={() => {
                            setIsSectionOpen(false);
                            scrollToTop();
                        }}
                    />
                    <div className="content-title">{itemData.title}</div>
                </div>

                <div className={`product-content-wrapper ${itemData?.style === 'style_8' ? 'custom' : ''}`}>
                    {!!itemData?.description && (
                        <p className={`item-description ${itemData?.style === 'style_6' ? 'care' : ''}`}>
                            <TextWithLinksParser text={itemData?.description}/>
                        </p>
                    )}

                    {!!itemData?.transportation && (
                        <div className="transportation">
                            <div className="title"> {itemData.transportation.name}</div>
                            <div className={`location-wrapper`}>
                                <img src={itemData.transportation.map} alt=""/>
                            </div>
                        </div>
                    )}

                    {itemData?.style === 'style_2' && (
                        <div className="product-type">
                            {itemData?.info?.map((item, index) => {
                                    const displayItemTitle = !!Number(item.info_data.count) && !item.info_progress?.every(item => !Number(item.progress));

                                    return (displayItemTitle && (
                                            <button
                                                key={index}
                                                type="button"
                                                onClick={() => setSelectedType(item.title)}
                                                className={`type ${selectedType === item.title ? 'active' : ''}`}
                                            >
                                                <p>{item.title}</p>
                                            </button>
                                        )
                                    )
                                }
                            )}
                        </div>
                    )}

                    {itemData?.style === 'style_1' &&
                        <ProductContentStyle1
                            items={itemData.info}
                            itemData={itemData}
                        />
                    }

                    {itemData?.style === 'style_2' &&
                        <ProductContentStyle2
                            items={itemData.info}
                            selectedType={selectedType}
                        />
                    }

                    {itemData?.style === 'style_3' &&
                        <ProductContentStyle3
                            items={itemData.info}
                        />
                    }

                    {itemData?.style === 'style_4' &&
                        <ProductContentStyle4
                            items={itemData.info}
                        />
                    }

                    {itemData?.style === 'style_5' &&
                        <ProductContentStyle5
                            items={itemData.info}
                        />
                    }


                    {itemData?.style === 'style_6' &&
                        <ProductContentStyle6
                            title={itemData.title}
                            items={itemData.info}
                        />
                    }

                    {itemData?.style === 'style_7' &&
                        <ProductContentStyle7
                            items={itemData.info}
                            isProductPassportView={isProductPassportView}
                        />
                    }

                    {itemData?.style === 'style_8' &&
                        <ProductContentStyle8
                            items={itemData.info}
                        />
                    }
                </div>
            </div>
        )
    }

    return null;

    // return !!itemData.title && (
    //     <div
    //         id={`${itemData.style}`}
    //         className="item"
    //         onClick={() => setIsSectionOpen(itemData.title)}
    //         // className={`product-item ${isOpen ? 'active' : ''} ${(showStyle4 || showStyle3) ? 'd-none' : ''}`}
    //     >
    //
    //         {/*<div*/}
    //         {/*    className={`product-item-title toggle`}*/}
    //         {/*    onClick={() => toggleBlock(isOpen)}*/}
    //         {/*>*/}
    //         {/*    <div className="info">*/}
    //         {/*        <div className="title">*/}
    //         {/*            {itemData.title}*/}
    //         {/*            <img src='/images/arrow-expand.svg' alt="" className={`expand ${isOpen ? 'on' : ''}`} />*/}
    //         {/*        </div>*/}
    //         {/*    </div>*/}
    //         {/*</div>*/}
    //
    //         {
    //             !isSectionOpen ?
    //                 <div className="item-title">{itemData.title}</div> : isSectionOpen === itemData.title ?
    //                     :
    //                     null
    //         }
    //     </div>
    // )
}
